import type { DropPointInput } from '@chukua/common';
import { Form, Input, Modal } from 'antd';
import { useEffect } from 'react';
import type { DropPoint } from '../../../jobs.api';
import { ZoneSearchSelect } from '../../../../zones/public/ZoneSearchSelect';

interface DropPointModalProps {
  open: boolean;
  /** The stop being edited, or null when adding a new one. */
  dropPoint: DropPoint | null;
  submitting: boolean;
  onSubmit: (input: DropPointInput) => Promise<boolean>;
  onCancel: () => void;
}

/** Add a drop point, or edit an existing one — same fields either way. A stop can be any active zone, no kind restriction. */
export function DropPointModal({ open, dropPoint, submitting, onSubmit, onCancel }: DropPointModalProps) {
  const [form] = Form.useForm<DropPointInput>();

  useEffect(() => {
    if (open) form.setFieldsValue({ zoneCode: dropPoint?.zoneCode, contactName: dropPoint?.contactName ?? '', contactPhone: dropPoint?.contactPhone ?? '' });
  }, [open, dropPoint, form]);

  async function submit() {
    await onSubmit(await form.validateFields());
  }

  return (
    <Modal
      open={open}
      title={dropPoint ? 'Edit drop point' : 'Add drop point'}
      onOk={submit}
      onCancel={onCancel}
      confirmLoading={submitting}
      destroyOnClose
      okText={dropPoint ? 'Save' : 'Add'}
    >
      <Form<DropPointInput> form={form} layout="vertical" requiredMark={false}>
        <Form.Item name="zoneCode" label="Zone" rules={[{ required: true, message: 'Select a zone' }]}>
          <ZoneSearchSelect />
        </Form.Item>
        <Form.Item name="contactName" label="Contact name" rules={[{ required: true, message: 'Enter a contact name' }]}>
          <Input autoFocus />
        </Form.Item>
        <Form.Item name="contactPhone" label="Contact phone" rules={[{ required: true, message: 'Enter a contact phone' }]}>
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
}
